import React, { useEffect } from "react";
import { Control, Controller, UseFormSetValue } from "react-hook-form";
import Select from "react-select";
import { useAuth } from "../../../../auth/context/AuthProvider";

interface PropertySelectComponentProps {
    setValue: UseFormSetValue<any>;
    control: Control<any>;
    errors: any;
}

const PropertySelectComponent: React.FC<PropertySelectComponentProps> = ({ setValue, control, errors }) => {
    const { user } = useAuth();

    // Convert properties object to an array
    const propertyArray = Object.entries(user?.properties || {}).map(([id, name]) => ({
        value: id,
        label: name as string,
    }));

    // Add "Select All Properties" option
    const selectAllOption = { value: "all", label: "Select All Properties" };
    const optionsWithAll = [selectAllOption, ...propertyArray];

    useEffect(() => {
        if (user?.active_property_id) {
            setValue("property_id", user.active_property_id, { shouldValidate: true });
        }
    }, [user, setValue]);

    return (
        <div>
            <label className="me-2">Current Property:</label>
            {propertyArray.length > 0 ? (
                <Controller
                    name="property_id"
                    control={control}
                    rules={{ required: "Property selection is required" }}
                    render={({ field: { value } }) => {
                        const selectedValues = value?.split(",") || [];

                        return (
                            <>
                                <Select
                                    isMulti
                                    options={optionsWithAll}
                                    value={
                                        selectedValues.includes("all")
                                            ? [selectAllOption] // Show only "Select All Properties" when all are selected
                                            : propertyArray.filter(option => selectedValues.includes(option.value))
                                    }
                                    onChange={(selectedOptions) => {
                                        const selected = selectedOptions.map(option => option.value);

                                        if (selected.includes("all")) {
                                            setValue(
                                                "property_id",
                                                propertyArray.map(option => option.value).join(","),
                                                { shouldValidate: true }
                                            );
                                        } else {
                                            setValue("property_id", selected.join(","), { shouldValidate: true });
                                        }
                                    }}
                                    className={errors.property_id ? "is-invalid" : ""}
                                />
                                {errors.property_id && (
                                    <div className="invalid-feedback">
                                        {errors.property_id.message as string}
                                    </div>
                                )}
                            </>
                        );
                    }}
                />
            ) : (
                <Select isDisabled options={[]} placeholder="No properties available" />
            )}
        </div>
    );
};

export default PropertySelectComponent;